export default {
  app: {
    notFound: {
      title: 'Pagina non trovata.',
      subtitle: 'Sembra che tu ti sia perso.',
      text: 'Non preoccuparti, ti aiuteremo a navigare da qui',
    },
  },
};
